// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/nebula.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.homepage {
  align-items: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  opacity: 0; /* start hidden for animation */
  position: relative;
  width: 100vw;
}

/* Overlay to darken background */
.overlay {
  background: rgba(0, 0, 0, 0.5);
  height: 100%;
  left: 0;
  opacity: 0; /* start hidden for animation */
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;
}

.overlay-raised {
  z-index: 3;
}

/* Logo container */
.logo-container {
  align-items: center;
  display: flex;
  flex-grow: 0.3;
  justify-content: center;
  opacity: 0; /* start hidden for animation */
  position: relative;
  z-index: 2;
}

/* Logo image */
.logo {
  height: auto;
  width: 20rem;
}

.button-container {
  align-items: top;
  display: flex;
  justify-content: center;
  opacity: 0; /* start hidden for animation */
  padding: 0 0 7em 0;
  position: relative;
  z-index: 2;
}

.apps-button {
  align-self: start;
  display: flex;
  position: relative;
  z-index: 2;
}

.utils-button {
  align-self: start;
  display: flex;
  position: relative;
  z-index: 2;
}

.contact-button {
  align-self: start;
  display: flex;
  position: relative;
  z-index: 2;
}

/* Fade-in animation */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.fade-in {
  animation: fadeIn 1s ease-in forwards;
}

.fade-in-delay1s {
  animation: fadeIn 2s ease-in forwards;
  animation-delay: 1s;
}

.fade-in-delay2s {
  animation: fadeIn 2s ease-in forwards;
  animation-delay: 2s;
}

.fade-in-delay3s {
  animation: fadeIn 2s ease-in forwards;
  animation-delay: 3s;
}

.fade-in-delay4s {
  animation: fadeIn 2s ease-in forwards;
  animation-delay: 4s;
}

/* Zoom-in + fade animation for logo */
@keyframes zoomInFade {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.zoom-in-delay1s {
  animation: zoomInFade 2s ease-out forwards;
  animation-delay: 1s;
}

.zoom-in-delay2s {
  animation: zoomInFade 2s ease-out forwards;
  animation-delay: 2s;
}

.zoom-in-delay3s {
  animation: zoomInFade 2s ease-out forwards;
  animation-delay: 3s;
}

/* Footer styles */
.footer {
  bottom: 1rem;
  color: #fff;
  font-size: 0.9rem;
  opacity: 0; /* start hidden for animation */
  position: absolute;
  text-align: center;
  width: 100%;
  z-index: 2;
}

.square-peg-regular {
  font-family: "Square Peg", cursive;
  font-size:x-large;
  font-style: normal;
  font-weight: 400;
}

.padding-1 {
  padding-left: 1em;
  padding-right: 1em;
}
`, "",{"version":3,"sources":["webpack://./src/css/App.css"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,yDAA6C;EAC7C,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,UAAU,EAAE,+BAA+B;EAC3C,kBAAkB;EAClB,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE,8BAA8B;EAC9B,YAAY;EACZ,OAAO;EACP,UAAU,EAAE,+BAA+B;EAC3C,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,UAAU,EAAE,+BAA+B;EAC3C,kBAAkB;EAClB,UAAU;AACZ;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,UAAU,EAAE,+BAA+B;EAC3C,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,UAAU,EAAE,+BAA+B;EAC3C,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["\n.homepage {\n  align-items: center;\n  background-image: url('../images/nebula.jpg');\n  background-size: cover;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  justify-content: center;\n  opacity: 0; /* start hidden for animation */\n  position: relative;\n  width: 100vw;\n}\n\n/* Overlay to darken background */\n.overlay {\n  background: rgba(0, 0, 0, 0.5);\n  height: 100%;\n  left: 0;\n  opacity: 0; /* start hidden for animation */\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: 1;\n}\n\n.overlay-raised {\n  z-index: 3;\n}\n\n/* Logo container */\n.logo-container {\n  align-items: center;\n  display: flex;\n  flex-grow: 0.3;\n  justify-content: center;\n  opacity: 0; /* start hidden for animation */\n  position: relative;\n  z-index: 2;\n}\n\n/* Logo image */\n.logo {\n  height: auto;\n  width: 20rem;\n}\n\n.button-container {\n  align-items: top;\n  display: flex;\n  justify-content: center;\n  opacity: 0; /* start hidden for animation */\n  padding: 0 0 7em 0;\n  position: relative;\n  z-index: 2;\n}\n\n.apps-button {\n  align-self: start;\n  display: flex;\n  position: relative;\n  z-index: 2;\n}\n\n.utils-button {\n  align-self: start;\n  display: flex;\n  position: relative;\n  z-index: 2;\n}\n\n.contact-button {\n  align-self: start;\n  display: flex;\n  position: relative;\n  z-index: 2;\n}\n\n/* Fade-in animation */\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.fade-in {\n  animation: fadeIn 1s ease-in forwards;\n}\n\n.fade-in-delay1s {\n  animation: fadeIn 2s ease-in forwards;\n  animation-delay: 1s;\n}\n\n.fade-in-delay2s {\n  animation: fadeIn 2s ease-in forwards;\n  animation-delay: 2s;\n}\n\n.fade-in-delay3s {\n  animation: fadeIn 2s ease-in forwards;\n  animation-delay: 3s;\n}\n\n.fade-in-delay4s {\n  animation: fadeIn 2s ease-in forwards;\n  animation-delay: 4s;\n}\n\n/* Zoom-in + fade animation for logo */\n@keyframes zoomInFade {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.zoom-in-delay1s {\n  animation: zoomInFade 2s ease-out forwards;\n  animation-delay: 1s;\n}\n\n.zoom-in-delay2s {\n  animation: zoomInFade 2s ease-out forwards;\n  animation-delay: 2s;\n}\n\n.zoom-in-delay3s {\n  animation: zoomInFade 2s ease-out forwards;\n  animation-delay: 3s;\n}\n\n/* Footer styles */\n.footer {\n  bottom: 1rem;\n  color: #fff;\n  font-size: 0.9rem;\n  opacity: 0; /* start hidden for animation */\n  position: absolute;\n  text-align: center;\n  width: 100%;\n  z-index: 2;\n}\n\n.square-peg-regular {\n  font-family: \"Square Peg\", cursive;\n  font-size:x-large;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.padding-1 {\n  padding-left: 1em;\n  padding-right: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
